// extracted by mini-css-extract-plugin
module.exports = {"call-to-action":"call-to-action___3WoKS","callToAction":"call-to-action___3WoKS"};